import * as $ from "jquery";
import imkt from '../imkt';
import storage from "../utils/storage";
import tracking from '../utils/tracking';
import Modal from '../components/generic/modal';

export default {
  data: {},
  // returns a file extension of a file name
  getFileExtension: function (fileName: string) {
    var fileExtension;
    try {
      fileExtension = fileName.split(".").pop();
    } catch (error) {
      fileExtension = "";
    }
    switch (fileExtension) {
      case "gz":
        return "TAR.GZ";
      default:
        return fileExtension.toUpperCase();
    }
  },

  // returns a file name (everthing after the last / of the url);
  getFileName: function (filePath: string) {
    var fileName;
    try {
      fileName = filePath.substr(filePath.lastIndexOf("/") + 1);
    } catch (error) {
      fileName = "Unknown";
    }
    return fileName;
  },

  // returns the OS you're on
  getOS: function () {
    if (navigator.appVersion.indexOf("Mac") !== -1) {
      return "Mac";
    } else if (
      navigator.appVersion.indexOf("X11") !== -1 ||
      navigator.appVersion.indexOf("Linux") !== -1
    ) {
      return "Unix";
    } else {
      return "Windows";
    }
  },

  // creates a select2 dropdown on the selector you pass in
  select2: function (selector: JQuery<HTMLElement>) {
    if (selector.length) {
      $.getScript(
        imkt.constants.libPath + "select2.js" + imkt.constants.cdnVersionQuery
      ).done(function () {
        selector.select2({ minimumResultsForSearch: -1 });
      });
    }
  },

  // gets underscore.js and then calls the funciton you pass in
  underscore: function (callback) {
    var underscoreRequest = $.Deferred();
    // underscore is a dependency, so load that first
    if (typeof _ === "undefined") {
      underscoreRequest = $.getScript(
        imkt.constants.libPath +
          "underscore.js" +
          imkt.constants.cdnVersionQuery
      );
    } else {
      // underscore already exists
      underscoreRequest.resolve();
    }
    $.when(underscoreRequest).then(callback);
  },

  // Organizes data from JSONP in OS and calls cloneData() to integrate structured data
  retrieveData: function (
    data,
    callback,
    context,
    type,
    isEnterprise,
    customArray,
    ignoreLabeling
  ) {
    var self = this;
    type = isEnterprise ? "enterprise" : type;
    var dataVariable = customArray ? customArray : "data";
    var defaultData = context.params.downloadInfo.Default || [];
    var macData = context.params.downloadInfo.Mac || [];
    var linuxData = context.params.downloadInfo.Unix || [];
    var windowsData = context.params.downloadInfo.Windows || [];
    context[dataVariable] = {
      Default: [],
      Mac: [],
      Unix: [],
      Windows: [],
    };
    data.forEach(function (download) {
      if (download.platform.indexOf("Mac") > -1) {
        self.cloneData(
          "Mac",
          macData,
          download,
          context,
          type,
          isEnterprise,
          customArray,
          ignoreLabeling
        );
      }
      if (download.platform.indexOf("Unix") > -1) {
        self.cloneData(
          "Unix",
          linuxData,
          download,
          context,
          type,
          isEnterprise,
          customArray,
          ignoreLabeling
        );
      }
      if (download.platform.indexOf("Windows") > -1) {
        self.cloneData(
          "Windows",
          windowsData,
          download,
          context,
          type,
          isEnterprise,
          customArray,
          ignoreLabeling
        );
      }
      self.cloneData(
        "Default",
        defaultData,
        download,
        context,
        type,
        isEnterprise,
        customArray,
        ignoreLabeling
      );
    });
    callback(context, isEnterprise);
  },

  // Clones original objects from JSONP and mashes them up with data from structured data in Magnolia
  cloneData: function (
    os,
    osData,
    download,
    context,
    type,
    isEnterprise,
    customArray,
    ignoreLabeling
  ) {
    var self = this;
    var dataVariable = customArray ? customArray : "data";
    if (osData.length > 0) {
      osData.forEach(function (object) {
        var shouldPopulate =
          download.description.indexOf(object.descriptionKey) > -1 ||
          ignoreLabeling;
        if (shouldPopulate) {
          var clonedObject = Object.assign({}, download);
          var fileExtension = self.getFileExtension(clonedObject.zipUrl);
          var fileName = self.getFileName(clonedObject.zipUrl);
          if (
            object.fileExtension !== "none" &&
            fileExtension !== object.fileExtension
          ) {
            return true;
          }
          switch (type) {
            case "update":
              clonedObject.show = object.includeUpdate;
              break;
            case "enterprise":
              clonedObject.show = object.includeEnterprise;
              break;
            default:
              clonedObject.show = object.includeDownload;
              break;
          }
          clonedObject.displayName = object.descriptionValue;
          clonedObject.selected = object.selected;
          clonedObject.os = object.os;
          clonedObject.fileExtension = fileExtension;
          clonedObject.fileName = ignoreLabeling
            ? object.description
            : fileName;
          context[dataVariable][os].push(clonedObject);
        }
      });
    }
  },

  // build tracking data and return it
  buildTrackingData: function (selector) {
    var data = {
      productName: selector.data("product-name"),
      productPlatform: selector.data("product-platform"),
      productVersion: selector.data("product-version"),
      productReleaseDate: selector.data("product-release-date"),
      fileName: selector.data("file-name"),
      fileDescription: selector.data("file-description"),
      fileUrl: selector.data("file-url"),
      releaseNotes: selector.data("release-notes"),
      version: selector.data("version"),
    };
    return data;
  },

  // calls changeDownloadLink when selectElement is changed
  // parameter values are selected DOM elements
  changeDownload: function (
    selectElement,
    downloadLink,
    currentVersion,
    releaseNotes
  ) {
    var self = this;

    selectElement.change(function () {
      var $this = $(this);
      var selectedProduct = $this.find(":selected");
      self.data = self.buildTrackingData(selectedProduct);

      // update DOM
      if (downloadLink && downloadLink.data) {
        downloadLink.data("href", self.data.fileUrl);
      }
      if (releaseNotes && releaseNotes.attr) {
        releaseNotes.attr("href", self.data.releaseNotes);
      }
      if (currentVersion && currentVersion.text) {
        currentVersion.text(self.data.version);
      }
    });
  },

  // This pops up our downloads EULA in a modal and adds href to button if they agree. Also, switches between the download/post-download areas and updates post-download buttons with the href={{installer}} to the download file url. Lastly, it sends a tracking event to segment.
  download: function ($domRoot, $downloadModalButton, doNotShowPostContent?: boolean) {
    let self = this;
    let href;
    let downloadModal = $("#download-view-modal", $domRoot);
    let downloadArea = $("#download-area");
    let postDownloadArea = $("#post-download-area");
    let installerButton = postDownloadArea.find(".button");

    $downloadModalButton.on("click", function (e) {
      e.preventDefault();

      let clickedModalButton = $(this);
      href = clickedModalButton.data("href");
      let modalContainer = new Modal({
        modalType: "download wpl",
        contentClickToHide: false,
      });
      modalContainer.$modal.find(".modal-content").html(downloadModal);
      let downloadButton = modalContainer.$modal.find("#eula-downloads-button");
      let checkbox = modalContainer.$modal.find("#download-eula-checkbox");
      let cancel = modalContainer.$modal.find(".downloads-view__cancel");

      // EULA Events
      checkbox.off("change");
      checkbox.on("change", function () {
        if ($(this).is(":checked")) {
          downloadButton.removeClass("disabled");
          downloadButton.attr("href", href);
        } else {
          downloadButton.addClass("disabled");
          downloadButton.attr("href", "");
        }
      });
      checkbox.trigger("change");

      cancel.off("click");
      cancel.on("click", function () {
        modalContainer.hide();
      });

      downloadButton.off("click");
      downloadButton.on("click", function (e) {
        if (downloadButton.hasClass("disabled")) {
          e.preventDefault();
        } else {
          modalContainer.hide();
          if (clickedModalButton.hasClass("download-link--archive")) {
            self.data = self.buildTrackingData(clickedModalButton);
          }

          // Segment tracking call
          tracking.trackEvent("Started Download", self.data);

          // Show Post-download section
          if (postDownloadArea.length > 0 && !doNotShowPostContent) {
            $.each(installerButton, function () {
              if ($(this).attr("href") === "{{installer}}") {
                $(this).attr("href", href);
              }
            });
            downloadArea.addClass("inactive");
            postDownloadArea.addClass("active");
          }
        }
      });
      modalContainer.show();
      modalContainer.place();
    });
  },
};
